module.exports = __webpack_public_path__ + "img/c89e968.png";